
export enum ThemeAnalyticsChartTypeEnum {
    // Summary
    SENTIMENT_SUMMARY = 'SENTIMENT_SUMMARY',
    SHARE_OF_VOICE_BY_SOCIAL_NETWORK = 'SHARE_OF_VOICE_BY_SOCIAL_NETWORK',
    SHARE_OF_VOICE_BY_SOCIAL_NETWORK_SUB = 'SHARE_OF_VOICE_BY_SOCIAL_NETWORK_SUB',
    SHARE_OF_VOICE_BY_SOCIAL_TOPIC = 'SHARE_OF_VOICE_BY_SOCIAL_TOPIC',
    SHARE_OF_VOICE_BY_SOCIAL_TOPIC_SUB = 'SHARE_OF_VOICE_BY_SOCIAL_TOPIC_SUB',
    SUMMARY_BY_SOCIAL_TOPIC = 'SUMMARY_BY_SOCIAL_TOPIC',
    SUMMARY_BY_SOCIAL_NETWORK = 'SUMMARY_BY_SOCIAL_NETWORK',
    // Sentiment
    SENTIMENT_BY_SOCIAL_MEDIA_COMPARISON = 'SENTIMENT_BY_SOCIAL_MEDIA_COMPARISON',
    SENTIMENT_BY_SOCIAL_TOPIC_COMPARISON = 'SENTIMENT_BY_SOCIAL_TOPIC_COMPARISON',
    SOCIAL_MEDIA_SENTIMENT_TREND = 'SOCIAL_MEDIA_SENTIMEMNT_TREND', // TYPO (SENTIMEMNT)
    SOCIAL_TOPIC_SENTIMENT_TREND = 'SOCIAL_TOPIC_SENTIMENT_TREND',

    // Engagement
    ENGAGEMENT_BY_SOCIAL_MEDIA_COMPARISON = 'ENGAGEMENT_BY_SOCIAL_MEDIA_COMPARISON',
    ENGAGEMENT_TYPE_BY_SOCIAL_MEDIA_COMPARISON = 'ENGAGEMENT_TYPE_BY_SOCIAL_MEDIA_COMPARISON',
    ENGAGEMENT_SUMMARY_PER_SOCIAL_MEDIA = 'ENGAGEMENT_SUMMARY_PER_SOCIAL_MEDIA',
    SOCIAL_MEDIA_ENGAGEMENT = 'SOCIAL_MEDIA_ENGAGEMENT',
}
